import { Box } from "@mui/material";
import logo from "../assets/logo.png";
import imageHeader from "../assets/landing/image-header2.png";
import { colors } from "../utils/constants";

interface AuthSidePanelProps {
  headline?: string;
  subtext?: string;
}

const photoFade =
  "linear-gradient(115deg, transparent 0%, rgba(0,0,0,0.35) 20%, black 42%, black 100%)";

export default function AuthSidePanel({
  headline = "Certificados que provam presença de verdade.",
  subtext = "Acesse sua conta e gerencie seus eventos e certificados em poucos cliques.",
}: AuthSidePanelProps) {
  return (
    <Box style={styles.panel} className="auth-side-panel">
      <Box style={styles.photoLayer}>
        <img src={imageHeader} style={styles.photoImg} alt="" />
        <Box style={styles.photoOverlay} />
      </Box>

      <Box style={styles.panelContent}>
        <img src={logo} style={styles.panelLogo} alt="Certify.me" />
        <span style={styles.panelHeadline}>{headline}</span>
        <span style={styles.panelSubtext}>{subtext}</span>
      </Box>
    </Box>
  );
}

const styles: any = {
  panel: {
    position: "relative",
    flex: 2,
    minHeight: "100%",
    overflow: "hidden",
    background:
      "linear-gradient(135deg, #0060DF 0%, #0097FF 45%, #5EC8FF 100%)",
    display: "flex",
    flexDirection: "column",
  },

  photoLayer: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    width: "70%",
    overflow: "hidden",
    maskImage: photoFade,
    WebkitMaskImage: photoFade,
  },

  photoImg: {
    position: "absolute",
    right: "-4%",
    bottom: 0,
    height: "102%",
    width: "auto",
    maxWidth: "none",
    filter: "grayscale(1) contrast(1.12) brightness(1.05)",
  },

  photoOverlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(205deg, rgba(0,40,130,0.7) 0%, rgba(0,120,220,0.4) 55%, rgba(120,210,255,0.18) 100%)",
    mixBlendMode: "color",
  },

  panelContent: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    padding: "48px",
    maxWidth: 460,
  },

  panelLogo: {
    width: 170,
    objectFit: "contain",
    marginBottom: 48,
  },

  panelHeadline: {
    fontSize: 32,
    fontWeight: 700,
    lineHeight: 1.2,
    color: colors.white,
    letterSpacing: "-0.01em",
  },

  panelSubtext: {
    fontSize: 15,
    color: "rgba(255,255,255,0.85)",
    marginTop: 16,
    lineHeight: 1.6,
  },
};
